import Vue from 'vue'
import VueRouter from 'vue-router'
import PageTitleManager from '~utils/page-title-manager'
import focusReset from '~utils/focus-reset'
import RouterViewWrapper from '~components/router-view-wrapper/router-view-wrapper'

export default (brand, {
  brandConfig,
  ImprintPage,
  TermsOfUsePage,
  TermsOfUsePageCompensation,
  VoucherSaleAmountPage,
  VoucherSaleCheckoutPage,
  VoucherSaleConfirmationPage,
  VoucherSaleLandingPage,
  FAQPage,
  WithdrawalPage,
},
locales = ['en'],
defaultLocale = 'en') => {
  const allowedLocalesRegex = locales.join('|')

  const routes = [
    {
      path: `/:locale(${allowedLocalesRegex})?`,
      component: RouterViewWrapper,
      children: [
        {
          path: '', component: VoucherSaleLandingPage, name: 'voucherSaleLanding',
        },
        {
          path: 'buy', component: VoucherSaleAmountPage, name: 'voucherSaleAmount',
        },
        {
          path: 'checkout', component: VoucherSaleCheckoutPage, name: 'voucherSaleCheckout',
        },
        {
          path: 'confirmation', component: VoucherSaleConfirmationPage, name: 'voucherSaleConfirmation',
        },
        ...(ImprintPage ? [
          {
            path: 'imprint', component: ImprintPage, name: 'imprint',
          }] : []
        ),
        ...(FAQPage ? [
          {
            path: 'faq', component: FAQPage, name: 'faq',
          }] : []
        ),
        ...(WithdrawalPage ? [
          {
            path: 'withdrawal', component: WithdrawalPage, name: 'withdrawal',
          }] : []
        ),
        ...(TermsOfUsePage ? [{
          path: 'terms-of-use', component: TermsOfUsePage, name: 'termsOfUse',
        }] : []),
      ],
    },
    {
      path: '/:locale(en)?',
      component: RouterViewWrapper,
      children: [
        TermsOfUsePageCompensation && {
          name: 'termsOfUseCompensation',
          path: 'terms-of-use-compensation',
          component: TermsOfUsePageCompensation,
          meta: { hideFooter: true, headerHref: 'https://lufthansa.com' },
        },
      ].filter(Boolean),
    },
    {
      path: '*', redirect: { name: 'voucherSaleLanding' },
    },
  ]

  Vue.use(VueRouter)

  const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to) {
      if (to.hash) {
        return window.scrollTo(0, (document.querySelector(to.hash).offsetTop - brandConfig.header.offset))
      }

      return window.scrollTo(0, 0)
    },
  })

  router.beforeEach((to, from, next) => {
    const i18n = router.app.$i18n

    const requestedLocale = Array.isArray(to.params.locale) ? to.params.locale[0] : to.params.locale

    if (requestedLocale && i18n.availableLocales.includes(requestedLocale)) {
      document.documentElement.lang = requestedLocale
      i18n.locale = requestedLocale
    } else {
      document.documentElement.lang = defaultLocale
      i18n.locale = defaultLocale
    }

    new PageTitleManager(document, i18n).update(to.name)

    next()
  })

  router.afterEach((to) => {
    if (!to.hash) {
      focusReset('focusResetAnchor')
    }
  })

  return router
}
